// cncProjection.ts — CNC 산출 결과(1ea)를 견적 LineItem 으로 투영 (순수).
// 불변식: lineCalc(item).submit === result.productCost.
//   internal = mat+proc+etc = productCost − profit.
//   lineCalc 가 Margin(판매가 기준): submit = internal ÷ (1 − margin/100) 이므로
//   margin = profit/productCost×100 (판매가 대비) 로 역산해야 submit == productCost 가 된다.
//   검산: internal ÷ (1 − profit/productCost) = internal ÷ (internal/productCost) = productCost.
import type { CncQuoteResult } from "@/lib/cost/cncQuote";
import type { CncPart, LineItem } from "@/lib/data";

export function cncResultToLineItem(
  result: CncQuoteResult,
  label: { item: string; spec: string },
  id: number
): LineItem {
  const mat = result.material.materialCost;
  const proc = result.processing.processingTotal;
  const etc = result.generalAdmin + result.materialAdmin + result.moldCost + result.miscCost;
  const internal = mat + proc + etc;
  // 판매가 기준 마진율 = 이윤 / 제품원가 × 100 (제품원가 = internal + profit).
  // internal ≤ 0 이면 마진율로 손실 없이 표현 불가(margin→100% 분모 0) → 0 으로 두어
  // lineCalc 의 applyMargin 가드와 일관되게 submit=internal 을 유지(불변식 보존).
  const margin = internal > 0 ? (result.profit / result.productCost) * 100 : 0;
  return {
    id,
    item: label.item,
    spec: label.spec,
    unit: "EA",
    qty: 1,
    mat,
    proc,
    etc,
    margin,
    note: "CNC 자동 산출",
  };
}

// 라벨 없이(빈 문자열) 파트→아이템 일괄 투영. 표시명은 컴포넌트가 별도 부여한다.
export function cncPartsToLineItems(parts: CncPart[]): LineItem[] {
  return parts.map((p, i) => cncResultToLineItem(p.result, { item: "", spec: "" }, i + 1));
}
